var classes = {"colorSwatchGroupColor":"hHICY"};

export { classes as default };
